/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedAvailabilityResult } from '../../models/paginated-availability-result';

export interface CatalogEntriesCatalogEntryIdAvailabilitiesGet$Params {
  'Active-Tenant-Identifier': string;
  catalogEntryId: string;

/**
 * This is required at least for 'MODIFIER' to avoid an initial lookup and find by context
 */
  catalogType?: string;
  size?: string;
  start?: string;
}

export function catalogEntriesCatalogEntryIdAvailabilitiesGet(http: HttpClient, rootUrl: string, params: CatalogEntriesCatalogEntryIdAvailabilitiesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedAvailabilityResult>> {
  const rb = new RequestBuilder(rootUrl, catalogEntriesCatalogEntryIdAvailabilitiesGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('catalogEntryId', params.catalogEntryId, {});
    rb.query('catalogType', params.catalogType, {});
    rb.query('size', params.size, {});
    rb.query('start', params.start, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedAvailabilityResult>;
    })
  );
}

catalogEntriesCatalogEntryIdAvailabilitiesGet.PATH = '/catalog-entries/{catalogEntryId}/availabilities';
